module.exports = __webpack_public_path__ + "static/media/auto-escalation.9fd01a10.svg";